__turbopack_context__.v({
  "imageWrapper": "WeeklyProductCard-module-scss-module__aiOi6a__imageWrapper",
  "link": "WeeklyProductCard-module-scss-module__aiOi6a__link",
  "name": "WeeklyProductCard-module-scss-module__aiOi6a__name",
  "nameBold": "WeeklyProductCard-module-scss-module__aiOi6a__nameBold",
  "nameSmall": "WeeklyProductCard-module-scss-module__aiOi6a__nameSmall",
  "oldPrice": "WeeklyProductCard-module-scss-module__aiOi6a__oldPrice",
  "price": "WeeklyProductCard-module-scss-module__aiOi6a__price",
  "priceBlock": "WeeklyProductCard-module-scss-module__aiOi6a__priceBlock",
  "textBlock": "WeeklyProductCard-module-scss-module__aiOi6a__textBlock",
  "title": "WeeklyProductCard-module-scss-module__aiOi6a__title",
  "titleMobile": "WeeklyProductCard-module-scss-module__aiOi6a__titleMobile",
  "wrapper": "WeeklyProductCard-module-scss-module__aiOi6a__wrapper",
});
